import { ACTION_TYPES, USER_OPR_STATE, SERVER_OPR_STATE } from '../constants';
import { createReducer } from '@reduxjs/toolkit';

const dummyId = -9;

// =============================================
// Reducer at category level of the oprs branch:
// =============================================
// eslint-disable-next-line import/no-default-export -- FIXME: Convert to a named export https://github.com/wegotpop/popsss/wiki/Imports#default-exports
export default createReducer({}, (builder) => {
  // ------------------
  // User interactions:
  // ------------------

  builder
    .addCase(ACTION_TYPES.EDIT_CTG, (state, action) => {
      state[action.category.group_id] = {
        ...state[action.category.group_id],
        [USER_OPR_STATE.IN_EDITING]: true,
      };
      return state;
    })

    .addCase(ACTION_TYPES.CANCEL_CTG_EDIT, (state, action) => {
      state[action.category.group_id] = {
        ...state[action.category.group_id],
        [USER_OPR_STATE.IN_EDITING]: false,
      };
      return state;
    })

    .addCase(ACTION_TYPES.EXPAND_CTG, (state, action) => {
      state[action.category.group_id] = {
        ...state[action.category.group_id],
        [USER_OPR_STATE.EXPANDED]: true,
      };
      return state;
    })
    .addCase(ACTION_TYPES.COLLAPSE_CTG, (state, action) => {
      state[action.category.group_id] = {
        ...state[action.category.group_id],
        [USER_OPR_STATE.EXPANDED]: false,
      };
      return state;
    })

    // --------------------
    // Server interactions:
    // --------------------

    .addCase(ACTION_TYPES.ADD_CTG_START, (state, action) => {
      state[dummyId] = { [SERVER_OPR_STATE.ADD]: SERVER_OPR_STATE.ADDING };
      return state;
    })

    .addCase(ACTION_TYPES.ADD_CTG_SUCCESSFUL, (state, action) => {
      state[action.category.group_id] = {
        [SERVER_OPR_STATE.ADD]: SERVER_OPR_STATE.ADDING_SUCCESSFUL,
      };
      delete state[dummyId];
      return state;
    })

    .addCase(ACTION_TYPES.ADD_CTG_FAILED, (state, action) => {
      state[dummyId] = {
        [SERVER_OPR_STATE.ADD]: SERVER_OPR_STATE.ADDING_FAILED,
      };
      return state;
    })

    // Special case require id not be reused if possible.
    .addCase(ACTION_TYPES.DELETE_CTG_START, (state, action) => {
      state[action.category.group_id] = {
        ...state[action.category.group_id],
        [SERVER_OPR_STATE.DELETE]: SERVER_OPR_STATE.DELETING,
      };
      return state;
    })

    .addCase(ACTION_TYPES.DELETE_CTG_SUCCESSFUL, (state, action) => {
      state[action.category.group_id] = {
        ...state[action.category.group_id],
        [SERVER_OPR_STATE.DELETE]: SERVER_OPR_STATE.DELETING_SUCCESSFUL,
      };
      return state;
    })

    .addCase(ACTION_TYPES.DELETE_CTG_FAILED, (state, action) => {
      state[action.category.group_id] = {
        ...state[action.category.group_id],
        [SERVER_OPR_STATE.DELETE]: SERVER_OPR_STATE.DELETING_FAILED,
      };
      return state;
    })

    .addCase(ACTION_TYPES.UPDATE_CTG_START, (state, action) => {
      state[action.category.group_id] = {
        ...state[action.category.group_id],
        [SERVER_OPR_STATE.UPDATE]: SERVER_OPR_STATE.UPDATING,
      };
      return state;
    })

    .addCase(ACTION_TYPES.UPDATE_CTG_SUCCESSFUL, (state, action) => {
      state[action.category.group_id] = {
        ...state[action.category.group_id],
        [SERVER_OPR_STATE.UPDATE]: SERVER_OPR_STATE.UPDATING_SUCCESSFUL,
      };
      return state;
    })
    .addCase(ACTION_TYPES.UPDATE_CTG_FAILED, (state, action) => {
      state[action.category.group_id] = {
        ...state[action.category.group_id],
        [SERVER_OPR_STATE.UPDATE]: SERVER_OPR_STATE.UPDATING_FAILED,
      };
      return state;
    });
});
